export const IS_SAVING_ACCOUNT = 'IS_SAVING_ACCOUNT';
export const IS_SAVING_PROJECT = 'IS_SAVING_PROJECT';
export const SET_ADDING_EMAIL = 'SET_ADDING_EMAIL';
export const RESET_ADDING_EMAIL = 'RESET_ADDING_EMAIL';
export const SET_VIEW_ACCOUNT = 'SET_VIEW_ACCOUNT';
export const SET_VIEW_PROJECT = 'SET_VIEW_PROJECT';
export const SET_SELECTED_PROJECT = 'SET_SELECTED_PROJECT';
export const SET_VIEW_HUB = 'SET_VIEW_HUB';
export const SET_SELECTED_HUB = 'SET_SELECTED_HUB';
